import React from 'react';
import { string } from 'prop-types';
import Icons from '../icons/collection';

var ModalIcon = function ModalIcon(_ref) {
  var _ref$iconVersion = _ref.iconVersion,
      iconVersion = _ref$iconVersion === void 0 ? 'Alert' : _ref$iconVersion,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#cf8154' : _ref$color,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '45px' : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '45px' : _ref$width;
  var IconVersion = Icons[iconVersion];
  return /*#__PURE__*/React.createElement(IconVersion, {
    height: height,
    width: width,
    fill: color,
    "data-test-id": "scl-icon-".concat(iconVersion)
  });
};

ModalIcon.propTypes = {
  /**
   Optional: the version of the icon for the modal. Use pascal case. See Icon for a list of icons.
  */
  iconVersion: string,

  /**
   Optional: external override for the color of the icon
  */
  color: string,

  /**
    Optional: height of the icon
   */
  height: string,

  /**
  Optional: width of the icon
  */
  width: string
};
export default ModalIcon;